/* eslint-disable react/no-array-index-key */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import HttpRequest from '@Services/RequestFactory';
import externalUrl from '@Utils/ExternalUrl';
import MessageBroker from '@Services/MessageBroker';
import InnerHTML from '@Components/InnerHTML';
import { MetadataPropTypesShape } from '@Components/Results/MetadataPropTypes';
import PrepareTrackingDataHelper from '@Services/PrepareTrackingDataHelper';
import { Button } from '@els/els-react--button';

const truncateAfter = 10;
const limitTo = 7;
const limitEnd = 2;

function ListOfAuthors({ citation, metadata, onAuthorClick }) {
  const [showAll, setShowAll] = useState((citation?.authors?.length || 0) <= truncateAfter);

  const authorLinkClick = (e, url) => {
    if (e) {
      e.preventDefault();
    }

    if (onAuthorClick) {
      onAuthorClick(citation);
    }

    if (url) {
      const newWindow = window.open('', '_blank');

      MessageBroker.send({ url: HttpRequest.getUrlWithPrefix(url), method: 'GET' })
        .then((data) => {
          if (data)
            newWindow.location.href =
              window.s && window.s.visitor ? window.s.visitor.appendVisitorIDsTo(externalUrl(data)) : externalUrl(data);
        })
        .catch(Logger.error);
    }
  };

  const allAuthorsClick = (e) => {
    if (e) {
      e.preventDefault();
    }

    setShowAll(true);
  };

  const getAuthors = () => {
    const authors = [...(citation.authors || [])];

    if (!showAll) {
      authors.splice(limitTo, authors.length - limitTo - limitEnd, { isShowMorePlaceholder: true });
    }

    return authors;
  };

  const getTrackingProps = () => {
    if (!metadata.oldTrackingDisabled) {
      return {
        ...PrepareTrackingDataHelper.prepare(citation),
        'data-click-delegation': true,
        'data-tracking': 'true',
        'data-tracking-type': 'linkout',
        'data-tracking-action': 'author name',
        'data-tracking-context': 'reactions',
        'data-tracking-preview': metadata?.isViewPreview,
      };
    }
    return {};
  };
  return (
    <>
      {/* eslint-disable-next-line custom/no-unsafe-deep-access */}
      {getAuthors().map((author, authorIndex, authors) =>
        author.isShowMorePlaceholder ? (
          <Button
            data-e2e="more-authors-link"
            key={`${authorIndex}-more-authors-link`}
            type="link"
            linkOptions={['inline']}
            onClick={(e) => {
              allAuthorsClick(e);
            }}>
            (&hellip;)
          </Button>
        ) : (
          <React.Fragment key={authorIndex}>
            {author.link ? (
              <Button
                data-e2e="author-link"
                key={`${authorIndex}-more-authors-link`}
                type="link"
                linkOptions={['inline', 'navigation']}
                {...getTrackingProps()}
                onClick={(e) => {
                  authorLinkClick(e, author.link);
                }}>
                <InnerHTML tag="span" html={author.author} />
              </Button>
            ) : (
              <InnerHTML tag="span" html={author.author} />
            )}
            {authorIndex < authors.length - 1 && '; '}
          </React.Fragment>
        )
      )}
    </>
  );
}

ListOfAuthors.propTypes = {
  metadata: MetadataPropTypesShape,
  citation: PropTypes.object.isRequired,
  onAuthorClick: PropTypes.func,
};

export default ListOfAuthors;
